export const request = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://localhost:3001' : window.location.origin;
//let page_slug = window.location.pathname.match(/([^\/]*)\/*$/)[1];

let API = {
    checkuser:           `${request}/api/get-allow`,
    home:                `${request}/api/get-home-info`,
    settings:            `${request}/api/get-settings`,
    //project_types:     `${request}/api/get-project-types`,
    //tags:              `${request}/api/get-tags`,
    filters:             `${request}/api/get-projects-filters`,
    projects:            `${request}/api/get-projects-list/:page`,
    // project:           `${request}/api/get-project/${page_slug}`,
    // page:              `${request}/api/get-page/${page_slug}`,
    project:             `${request}/api/get-project/:slug`,
    page:                `${request}/api/get-page/:slug`,
    page_about:          `${request}/api/get-page-about`,
    page_produce:        `${request}/api/get-page-produce`,
    pages_list:          `${request}/api/get-pages-list`,
    // types_for_project: `${request}/api/get-types-for-project/${page_slug}`,
    // tags_for_project:  `${request}/api/get-tags-for-project/${page_slug}`,
    types_for_project:   `${request}/api/get-types-for-project/:slug`,
    tags_for_project:    `${request}/api/get-tags-for-project/:slug`,
    conatcts_for_map:    `${request}/api/get-contacts-for-map`,
    navigation:          `${request}/api/get-navigation`,
    // slides:           `${request}/api/get-navigation`,
    contacts:            `${request}/api/get-contacts`,
    contact:             `${request}/api/get-contact/:slug`,
    services:            `${request}/api/get-services-list`,
    footer_info:         `${request}/api/get-footer-info`,
    footer_feedback:     `${request}/send-message`,
    header_icons:        `${request}/api/get-social-icons`,
    //service:           `${request}/api/get-service/${page_slug}`,
    // service:           `${request}/api/get-service/:slug`,
    service:             `${request}/api/get-service/:slug`,
    check_cookies:       `${request}/check-cookies`
};

export default API;
